/* Waslijn: sokken hangen aan een lijn en wapperen (veer-fysica). data = {socks:[{t,priceTxt,img,cut,url}], t:{...}} */
function sksLine(box, data, esc){
  var S = (data.socks || []).filter(function (s) { return s && s.img; });
  if (!S.length) return;
  var scroll = box.querySelector('.wl__scroll'), track = box.querySelector('.wl__track');
  var pegs = ['#ff6b9a', '#ffd84d', '#58c4ff', '#8ccd44', '#b98cff', '#ff9f43'];
  var socks = [], sag = 60, sagV = 0, W = 0, pad = 0, sp = 0, top = 34, t0 = performance.now(), last = t0, visible = true, gusting = 0;
  var svg = '<svg class="wl__line" preserveAspectRatio="none"><path d=""/></svg>';
  track.innerHTML = svg + '<i class="wl__pole" style="left:0"></i><i class="wl__pole" style="right:0"></i><span class="wl__bird" aria-hidden="true">🐦</span>';
  var path = track.querySelector('path'), bird = track.querySelector('.wl__bird'), poles = track.querySelectorAll('.wl__pole');
  S.forEach(function (s, i) {
    var a = document.createElement('a'); a.className = 'wl__sock' + (s.cut ? '' : ' photo'); a.href = s.url;
    a.style.setProperty('--peg', pegs[i % pegs.length]);
    a.innerHTML = '<i class="wl__peg"></i><img src="' + esc(s.img) + '" alt="' + esc(s.t) + '" loading="lazy"><span class="wl__tag">' + esc(s.t) + '<small>' + esc(s.priceTxt || '') + '</small></span>';
    track.appendChild(a);
    socks.push({ el: a, a: (Math.random() - .5) * 10, v: 0, ph: Math.random() * 6.28 });
  });
  var layout = function () {
    var cw = scroll.clientWidth, small = cw < 600;
    pad = small ? 44 : 60;
    sp = small ? 104 : Math.max(96, Math.min(150, (cw - pad * 2) / S.length));
    var sw = small ? 86 : Math.min(118, Math.round(sp * .88));
    W = Math.max(cw, Math.ceil(S.length * sp + pad * 2));
    track.style.width = W + 'px';
    track.style.setProperty('--sw', sw + 'px');
    var h = track.clientHeight;
    poles.forEach(function (p) { p.style.top = (top - 6) + 'px'; });
    var used = (S.length - 1) * sp, start = (W - used) / 2;
    socks.forEach(function (s, i) { s.x = start + i * sp; });
    bird.dataset.x = start + used * 0.5 + sp / 2;
  };
  var yAt = function (x) { var t = x / W; return top + 2 * t * (1 - t) * 2 * sag * (W / 1000 * .6 + .4) * .5; };
  var draw = function () {
    var cy = top + 2 * sag * (W / 1000 * .6 + .4) * .5;
    path.setAttribute('d', 'M0,' + top + ' Q' + (W / 2) + ',' + cy + ' ' + W + ',' + top);
    socks.forEach(function (s) {
      s.el.style.transform = 'translate(' + s.x.toFixed(1) + 'px,' + (yAt(s.x) - 2).toFixed(1) + 'px) rotate(' + s.a.toFixed(2) + 'deg)';
    });
    var bx = Number(bird.dataset.x) || W / 2;
    bird.style.left = bx + 'px'; bird.style.top = yAt(bx) + 'px';
  };
  var loop = function (now) {
    var dt = Math.min(.04, (now - last) / 1000); last = now;
    if (visible) {
      var tm = (now - t0) / 1000;
      sagV += (-(sag - 60) * 30 - sagV * 3) * dt; sag += sagV * dt;
      socks.forEach(function (s, i) {
        var breeze = Math.sin(tm * 1.3 + s.ph) * 150 + Math.sin(tm * .47 + i) * 90;
        if (gusting > 0) breeze += gusting * (0.6 + 0.4 * Math.sin(tm * 9 + i));
        s.v += (-(s.a) * 38 - s.v * 1.6 + breeze) * dt;
        s.a += s.v * dt;
        if (s.a > 75) { s.a = 75; s.v *= -.4; } if (s.a < -75) { s.a = -75; s.v *= -.4; }
      });
      gusting = Math.max(0, gusting - dt * 260);
      draw();
    }
    requestAnimationFrame(loop);
  };
  var blow = function () {
    gusting = 900; sagV -= 160;
    socks.forEach(function (s, i) { setTimeout(function () { s.v -= 160 + Math.random() * 160; }, i * 60); });
    if (!bird.classList.contains('away')) { bird.classList.add('away'); setTimeout(function () { bird.classList.remove('away'); }, 5200); }
  };
  // aanraken / muis: sokken wapperen mee met de beweging
  var lx = null, lt = 0;
  track.addEventListener('pointermove', function (e) {
    var r = track.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top, now = performance.now();
    if (lx != null && now > lt) {
      var vx = (x - lx) / ((now - lt) / 1000);
      socks.forEach(function (s) {
        var sy = yAt(s.x);
        if (Math.abs(s.x - x) < sp * .55 && y > sy && y < sy + 200) s.v -= Math.max(-900, Math.min(900, vx)) * .35;
      });
    }
    lx = x; lt = now;
  });
  track.addEventListener('pointerleave', function () { lx = null; });
  track.addEventListener('pointerdown', function (e) {
    var a = e.target.closest('.wl__sock'); if (!a) return;
    var s = socks.filter(function (x) { return x.el === a; })[0]; if (s) s.v += (Math.random() < .5 ? -1 : 1) * 260;
    if (e.pointerType === 'touch' && !a.classList.contains('show')) {
      socks.forEach(function (x) { x.el.classList.remove('show'); }); a.classList.add('show'); a._first = true;
    }
  });
  track.addEventListener('click', function (e) {
    var a = e.target.closest('.wl__sock'); if (a && a._first) { a._first = false; e.preventDefault(); }
  });
  var btn = box.querySelector('[data-wind]'); if (btn) btn.onclick = blow;
  if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0 }).observe(box);
  var auto = function () { if (visible && !document.hidden && !matchMedia('(prefers-reduced-motion: reduce)').matches) { gusting = 380; } setTimeout(auto, 7000 + Math.random() * 5000); };
  setTimeout(auto, 5000);
  layout(); window.addEventListener('resize', layout);
  if (scroll.scrollWidth > scroll.clientWidth) scroll.scrollLeft = (scroll.scrollWidth - scroll.clientWidth) / 2;
  requestAnimationFrame(loop);
}

/* Mismatch-maker: kies links en rechts een andere sok. data = {socks:[{h,t,e,priceTxt,cents,wasCents,img,cut,bg,url,...}], t:{...}}
   money(cents) → tekst, addDuo(sockA, sockB) → in mandje */
function sksDuo(box, data, esc, money, addDuo){
  var S = (data.socks || []).filter(function (s) { return s && s.h; });
  if (S.length < 2) return;
  var T = data.t || {};
  var lines = String(T.lines || '').split(/\n+/).map(function (x) { return x.trim(); }).filter(Boolean);
  if (!lines.length) lines = ['Gedurfd. Wij zijn fan.'];
  var idx = [0, 1], spinning = false;
  var good = function () { return S.filter(function (s) { return !s.bad; }).length; };
  var next = function (i, d, n) {
    for (var k = 0; k < S.length; k++) { i = (i + d + S.length) % S.length; if (!S[i].bad && (good() < 2 || i !== idx[1 - n] || S.length < 3)) return i; }
    return i;
  };
  var sides = [].slice.call(box.querySelectorAll('.duo__side'));
  var plus = box.querySelector('.duo__plus');
  var hash = function (a, b) { var s = a + '+' + b, h = 7; for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 9973; return h; };
  var paint = function (n, dir) {
    var s = S[idx[n]], el = sides[n];
    var pic = el.querySelector('.duo__pic');
    pic.style.setProperty('--c', s.bg || '#eee');
    var img = pic.querySelector('img');
    img.className = (s.cut ? 'cut ' : '') + (dir ? (dir < 0 ? 'in-l' : 'in-r') : '');
    img.onerror = function () {
      s.bad = true;
      if (!spinning && good() >= 2) { idx[n] = next(idx[n], dir || 1, n); paint(n, dir || 1); summary(); }
    };
    img.src = s.img || ''; img.alt = s.t;
    if (!s.img) img.onerror();
    pic.querySelector('.duo__emo').textContent = s.e || '';
    el.querySelector('.duo__name').innerHTML = '<a href="' + esc(s.url) + '">' + esc(s.t) + '</a>';
    el.querySelector('.duo__price').textContent = s.priceTxt || '';
  };
  var CATN = { food: 'Food', beesten: 'Beestenboel', mismatched: 'Mismatched', hobby: 'Hobby & fun', kerst: 'Kerst', packs: 'Voordeelpakketten' };
  if (T.catNames) for (var ck in T.catNames) CATN[ck] = T.catNames[ck];
  var nameOf = function (c) { return CATN[c] || (c ? c.charAt(0).toUpperCase() + c.slice(1) : ''); };
  var sameCatLines = ['Twee {cat}-sokken samen — dat klopt helemaal.', 'Eén stijl, twee sokken: lekker {cat}.', 'Logische combo: allebei uit {cat}.'];
  var mismLines = ['Mismatched zoals het hoort: expres niet gelijk. 😏', 'Dit is precies waar Mismatched om draait.', 'Bewust ongelijk, en daarom perfect.'];
  var mixLines = ['{catA} ontmoet {catB} — gedurfd maar het werkt.', 'Van {catA} naar {catB}: een combo met lef.', '{catA} en {catB} samen? Dat zie je niet vaak!', 'Deze mix van {catA} en {catB} verdient een applaus. 👏'];
  var summary = function () {
    var a = S[idx[0]], b = S[idx[1]];
    var same = a.h === b.h;
    var h = hash(a.h, b.h), msg, stars;
    if (same) { msg = T.same || 'Twee dezelfde? Ook prima… 😴'; stars = 2; }
    else if (a.cat === 'mismatched' || b.cat === 'mismatched') { msg = mismLines[h % mismLines.length]; stars = 5; }
    else if (a.cat && a.cat === b.cat) { msg = sameCatLines[h % sameCatLines.length].replace('{cat}', nameOf(a.cat).toLowerCase()); stars = 2 + (h % 2); }
    else if (a.cat && b.cat) { msg = mixLines[h % mixLines.length].replace('{catA}', nameOf(a.cat)).replace('{catB}', nameOf(b.cat)); stars = 3 + (h % 3); }
    else { msg = lines[h % lines.length]; stars = 3 + (h % 3); }
    box.querySelector('.duo__score b').textContent = msg;
    box.querySelector('.duo__score span').textContent = (T.level || 'Tegendraadsheid:') + ' ' + new Array(stars + 1).join('🔥') + new Array(6 - stars).join('·');
    var tot = (a.cents || 0) + (b.cents || 0), was = (a.wasCents || a.cents || 0) + (b.wasCents || b.cents || 0);
    box.querySelector('.duo__total').innerHTML = esc(T.total || 'Jouw duo') + '<b>' + (was > tot ? '<s>' + esc(money(was)) + '</s>' : '') + esc(money(tot)) + '</b>';
    var add = box.querySelector('[data-duo-add]');
    add.disabled = !(a.add !== false && b.add !== false);
    if (plus) { plus.classList.remove('pop'); void plus.offsetWidth; plus.classList.add('pop'); }
  };
  var step = function (n, d) { if (spinning) return; idx[n] = next(idx[n], d, n); paint(n, d); summary(); };
  sides.forEach(function (el, n) {
    el.querySelector('[data-prev]').onclick = function () { step(n, -1); };
    el.querySelector('[data-next]').onclick = function () { step(n, 1); };
    var pic = el.querySelector('.duo__pic'), x0 = null;
    pic.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    pic.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 35) step(n, dx < 0 ? 1 : -1); });
    pic.onclick = function () { step(n, 1); };
  });
  var shuffle = function () {
    if (spinning) return; spinning = true;
    var ok = []; S.forEach(function (s, i) { if (!s.bad) ok.push(i); });
    if (ok.length < 2) { spinning = false; return; }
    var a = ok[Math.floor(Math.random() * ok.length)], b;
    do { b = ok[Math.floor(Math.random() * ok.length)]; } while (b === a);
    var target = [a, b], ticks = [14, 22], t = 0;
    sides.forEach(function (el) { el.querySelector('.duo__pic').classList.add('spin'); });
    var tick = function () {
      t++;
      [0, 1].forEach(function (n) {
        if (t < ticks[n]) { idx[n] = next(idx[n], 1, n); paint(n, 0); }
        else if (t === ticks[n]) { idx[n] = target[n]; sides[n].querySelector('.duo__pic').classList.remove('spin'); paint(n, 1); }
      });
      if (t < ticks[1]) setTimeout(tick, 40 + t * t * 0.55);
      else { spinning = false; summary(); }
    };
    tick();
  };
  box.querySelector('[data-duo-shuffle]').onclick = shuffle;
  box.querySelector('[data-duo-add]').onclick = function () { addDuo(S[idx[0]], S[idx[1]]); };
  paint(0, 0); paint(1, 0); summary();
}

/* Sokkenmatch: 3 vragen → jouw sok. data = {questions:[{q, options:[{e,label,sock}]}], t:{...}}
   sock = {h,t,tag,e,priceTxt,wasTxt,img,cut,bg,ac,url,add}  (add = functie om toe te voegen) */
function sksQuiz(box, data, esc){
  var qs = (data.questions || []).filter(function (q) { return q.options && q.options.length; });
  var T = data.t || {};
  if (!qs.length) return;
  var card = box.querySelector('.quiz__card');
  var picks = [];
  var steps = function (n) { return '<div class="quiz__steps" aria-hidden="true">' + qs.map(function (_, i) { return '<i class="' + (i <= n ? 'on' : '') + '"></i>'; }).join('') + '</div>'; };
  var ask = function (n) {
    var q = qs[n];
    card.innerHTML = '<div class="quiz__pane">' + (n ? '<button type="button" class="quiz__back">← ' + esc(T.back || 'Terug') + '</button>' : '') + steps(n) +
      '<p class="quiz__q">' + esc(q.q) + '</p><div class="quiz__opts">' +
      q.options.map(function (o, i) { return '<button type="button" class="quiz__opt" data-i="' + i + '"><b>' + esc(o.e) + '</b><span>' + esc(o.label) + '</span></button>'; }).join('') + '</div></div>';
    card.querySelectorAll('.quiz__opt').forEach(function (b) {
      b.onclick = function () {
        b.classList.add('picked');
        picks[n] = q.options[Number(b.getAttribute('data-i'))].sock;
        setTimeout(function () { n + 1 < qs.length ? ask(n + 1) : result(); }, 260);
      };
    });
    var back = card.querySelector('.quiz__back'); if (back) back.onclick = function () { ask(n - 1); };
  };
  var result = function () {
    var chosen = picks.filter(Boolean), count = {}, best = null;
    chosen.forEach(function (s) { count[s.h] = (count[s.h] || 0) + 1; if (!best || count[s.h] > count[best.h]) best = s; });
    if (!best) return ask(0);
    if (count[best.h] < 2) {
      var fnv = function (s) { var h = 0x811c9dc5; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193); } return h >>> 0; };
      var mix = 0; chosen.forEach(function (s) { mix = (mix ^ fnv(s.h)) >>> 0; });
      best = chosen[mix % chosen.length];
    }
    var alts = [], seen = {}; seen[best.h] = 1;
    chosen.forEach(function (s) { if (!seen[s.h]) { seen[s.h] = 1; alts.push(s); } });
    card.innerHTML = '<div class="quiz__pane">' +
      '<div class="quiz__res" style="--c:' + esc(best.bg) + ';--ac:' + esc(best.ac) + '">' +
        '<div class="quiz__pic"><img class="' + (best.cut ? 'cut' : '') + '" src="' + esc(best.img) + '" alt="' + esc(best.t) + '"><span>' + esc(best.e || '') + '</span></div>' +
        '<div><p class="quiz__kicker">' + esc(T.result || 'Jouw sok is…') + '</p><h3>' + esc(best.t) + '</h3>' +
        (best.tag ? '<p class="quiz__tag">' + esc(best.tag) + '</p>' : '') +
        '<div class="price">' + (best.wasTxt ? '<s>' + esc(best.wasTxt) + '</s>' : '') + '<span class="now">' + esc(best.priceTxt) + '</span></div>' +
        '<div class="quiz__btns">' + (best.add ? '<button type="button" class="btn btn--accent" style="--theme-accent:' + esc(best.ac) + '" data-quiz-add>' + esc(T.add || 'In mijn mandje') + '</button>' : '') +
        '<a class="btn btn--ghost" href="' + esc(best.url) + '">' + esc(T.view || 'Bekijk deze sok') + '</a></div>' +
        (alts.length ? '<p class="quiz__alt">' + esc(T.alt || 'Ook iets voor jou:') + '<br>' + alts.map(function (a) { return '<a href="' + esc(a.url) + '"><img src="' + esc(a.img) + '" alt="">' + esc(a.t) + '</a>'; }).join('') + '</p>' : '') +
        '<button type="button" class="quiz__again">↺ ' + esc(T.again || 'Nog een keer') + '</button></div>' +
      '</div></div>';
    var add = card.querySelector('[data-quiz-add]'); if (add) add.onclick = function () { best.add(); };
    card.querySelector('.quiz__again').onclick = function () { picks = []; ask(0); };
    // feestje
    var c = document.createElement('div'); c.className = 'quiz__confetti';
    var em = (T.confetti || '🧦 🎉 ✨ 🌈') .split(/\s+/);
    for (var i = 0; i < 18; i++) { var s = document.createElement('span'); s.textContent = em[i % em.length]; s.style.left = (Math.random() * 100) + '%'; s.style.animationDelay = (Math.random() * .5) + 's'; c.appendChild(s); }
    box.appendChild(c); setTimeout(function () { c.remove(); }, 2600);
  };
  ask(0);
}

/* Sokkenstraat thema – interactie (mandje, hero, filters, productpagina) */
(function () {
  'use strict';
  var S = window.SKS || {};
  var T = S.t || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  // **vet** in teksten uit de instellingen
  var fmt = function (s, vars) {
    s = esc(s || '');
    Object.keys(vars || {}).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
    return s.replace(/\*\*(.+?)\*\*/g, '<b>$1</b>');
  };

  /* ---------- Geld ---------- */
  function money(cents) {
    var f = S.moneyFormat || '€{{amount_with_comma_separator}}';
    cents = Number(cents) || 0;
    var fix = function (n, d, th, dec) {
      var parts = (n / 100).toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(d ? dec : '');
    };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount': return fix(cents, 2, ',', '.');
        case 'amount_no_decimals': return fix(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fix(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fix(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fix(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fix(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return fix(cents, 2, ' ', '.');
        default: return fix(cents, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------- Kopbalk ---------- */
  var onScroll = function () { var h = $('#siteHeader'); if (h) h.classList.toggle('scrolled', window.scrollY > 10); };
  function initHeader() {
    var h = $('#siteHeader'); if (!h) return;
    window.removeEventListener('scroll', onScroll); window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    var b = $('#burger'), m = $('#menu');
    if (b && m) b.onclick = function () {
      var open = !m.classList.contains('open');
      m.classList.toggle('open', open); h.classList.toggle('menu-open', open);
      b.setAttribute('aria-expanded', open); b.textContent = open ? '✕' : '☰';
    };
  }

  /* ---------- Mandje ---------- */
  var cart = null, busy = false;
  function api(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  var routes = S.routes || {};
  var url = function (k, fallback) { return (routes[k] || fallback) + '.js'; };
  /* Voorbeeldmodus: mandje in de browser, afrekenen via de echte webshop */
  var DEMO = S.demo && S.demo.items ? S.demo : null, dcart = [];
  try { dcart = JSON.parse(localStorage.getItem('sks-demo-cart') || '[]'); } catch (e) {}
  if (!Array.isArray(dcart)) dcart = [];
  var saveDemo = function () { try { localStorage.setItem('sks-demo-cart', JSON.stringify(dcart)); } catch (e) {} };
  function demoCart() {
    dcart = dcart.filter(function (l) { return l && DEMO.items[l.h] && !DEMO.items[l.h].out && l.q > 0; });
    var n = 0, t = 0;
    var items = dcart.map(function (l) {
      var p = DEMO.items[l.h]; n += l.q; t += p.p * l.q;
      return { product_title: (p.e ? p.e + ' ' : '') + p.t, variant_title: '', url: (routes.search || '/search') + '?type=product&q=sok-' + l.h, image: p.img, bg: p.bg,
        quantity: l.q, final_line_price: p.p * l.q, original_line_price: p.p * l.q };
    });
    return { item_count: n, items: items, items_subtotal_price: t, total_price: t };
  }
  function loadCart() {
    if (DEMO) {
      // voorbeeldsokken + eventueel echte producten die je zelf in een sectie hebt gekozen
      var dc = demoCart();
      return api(url('cart', '/cart')).catch(function () { return { items: [], item_count: 0, items_subtotal_price: 0, total_price: 0 }; }).then(function (rc) {
        var realItems = (rc.items || []).map(function (it, i) { it._real = i + 1; return it; });
        dc.items.forEach(function (it, i) { it._demo = i + 1; });
        cart = { items: realItems.concat(dc.items), item_count: (rc.item_count || 0) + dc.item_count,
          items_subtotal_price: (rc.items_subtotal_price || 0) + dc.items_subtotal_price, total_price: (rc.total_price || 0) + dc.total_price, _realCount: rc.item_count || 0, _demoCount: dc.item_count };
        renderCart(); return cart;
      });
    }
    return api(url('cart', '/cart')).then(function (c) { cart = c; renderCart(); return c; });
  }
  function addDemo(h, q, open) {
    var p = DEMO.items[h]; if (!p || p.out) return;
    var l = dcart.filter(function (x) { return x.h === h; })[0];
    if (l) l.q += q; else dcart.push({ h: h, q: q });
    saveDemo(); loadCart(); bump();
    if (open) openCart(); else toast(fmt(T.added, { naam: esc((p.e ? p.e + ' ' : '') + p.t) }));
  }

  function renderCart() {
    var cnt = $('#cartCount'); if (cnt && cart) cnt.textContent = cart.item_count;
    var body = $('#cartBody'), foot = $('#cartFoot');
    if (!body || !cart) return;
    if (!cart.item_count) {
      body.innerHTML = '<div class="empty"><b>🧦</b><h3>' + esc(T.emptyTitle) + '</h3><p style="color:var(--muted);margin:8px 0 22px">' + fmt(T.emptyText) + '</p><a class="btn" href="' + esc(DEMO ? (routes.search || '/search') + '?q=pagina-shop' : (routes.shop || '/collections/all')) + '">' + esc(T.emptyBtn) + '</a></div>';
      foot.hidden = true; foot.innerHTML = ''; return;
    }
    var st = cart.items_subtotal_price, n = cart.item_count, free = Number(S.freeShip) || 0, min = Number(S.comboMin) || 0;
    var html = '';
    if (free > 0) html += '<div class="meter">' + (st >= free ? fmt(T.free) : fmt(T.toFree, { bedrag: money(free - st) })) + '<div class="bar"><i style="width:' + Math.min(100, st / free * 100) + '%"></i></div></div>';
    if (min > 0) html += '<div class="meter">' + (n >= min ? fmt(T.comboYes) : fmt(T.comboNo, { n: min - n })) + '</div>';
    html += cart.items.map(function (it, i) {
      var ln = it._demo ? 'd' + it._demo : (it._real || (i + 1));
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      if (it.featured_image && it.featured_image.url) img = it.featured_image.url + (it.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=200';
      if (it._demo) img = it.image;
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<small style="display:block;color:var(--muted)">' + esc(it.variant_title) + '</small>' : '';
      var was = it.original_line_price > it.final_line_price ? '<s style="font-weight:400;color:var(--muted);font-size:13px;margin-right:6px">' + money(it.original_line_price) + '</s>' : '';
      return '<div class="line">' +
        '<a class="line__img" style="--c:' + (it.bg || 'var(--soft)') + '" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') + '</a>' +
        '<div><h4>' + esc(it.product_title) + '</h4>' + variant +
        '<span class="mini-qty"><button type="button" data-line="' + ln + '" data-q="' + (it.quantity - 1) + '" aria-label="Minder">−</button><b>' + it.quantity + '</b><button type="button" data-line="' + ln + '" data-q="' + (it.quantity + 1) + '" aria-label="Meer">+</button></span>' +
        '<button type="button" class="rm" data-line="' + ln + '" data-q="0">' + esc(T.remove) + '</button></div>' +
        '<b>' + was + money(it.final_line_price) + '</b></div>';
    }).join('');
    body.innerHTML = html;
    foot.hidden = false;
    foot.innerHTML =
      '<div class="total"><span>' + fmt(T.subtotal, { n: n }) + '</span><span>' + money(cart.total_price) + '</span></div>' +
      (T.note ? '<p class="note">' + fmt(T.note) + '</p>' : '') +
      (DEMO && cart._demoCount
        ? '<a class="btn" href="' + esc(DEMO.shop.replace(/\/$/, '') + '/cart/' + dcart.map(function (l) { return DEMO.items[l.h].v + ':' + l.q; }).join(',')) + '">' + esc(T.checkout) + (cart._realCount ? ' (voorbeeldsokken)' : '') + '</a>'
        : '') +
      (!DEMO || cart._realCount
        ? '<form action="' + esc(routes.cart || '/cart') + '" method="post"' + (DEMO && cart._demoCount ? ' style="margin-top:8px"' : '') + '><button class="btn" type="submit" name="checkout">' + esc(T.checkout) + (DEMO && cart._demoCount ? ' (overige producten)' : '') + '</button></form>'
        : '');
  }

  function openCart() {
    var d = $('#drawer'); if (!d) return false;
    d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); $('#scrim').classList.add('open');
    if (!cart) loadCart();
    setTimeout(function () { var x = $('#closeCart'); if (x) x.focus(); }, 50);
    return true;
  }
  function closeCart() {
    var d = $('#drawer'); if (!d) return;
    d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); $('#scrim').classList.remove('open');
  }
  var tt;
  function toast(m) {
    var t = $('#toast'); if (!t || !m) return;
    t.innerHTML = m; t.classList.add('show'); clearTimeout(tt);
    tt = setTimeout(function () { t.classList.remove('show'); }, 2200);
  }
  function bump() { var b = $('#cartBtn'); if (b) { b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); } }

  function add(id, qty, name, open) {
    if (busy) return Promise.resolve();
    busy = true;
    return api(url('cartAdd', '/cart/add'), { items: [{ id: Number(id), quantity: qty || 1 }] })
      .then(function () { return loadCart(); })
      .then(function () { bump(); if (open) openCart(); else toast(fmt(T.added, { naam: esc(name || '') })); })
      .catch(function (e) { toast(esc((e && (e.description || e.message)) || T.error)); })
      .then(function () { busy = false; });
  }
  function change(line, q) {
    if (DEMO && String(line).charAt(0) === 'd') { var l = dcart[Number(String(line).slice(1)) - 1]; if (l) { l.q = Math.max(0, q); saveDemo(); } return loadCart(); }
    return api(url('cartChange', '/cart/change'), { line: Number(line), quantity: Math.max(0, q) })
      .then(function (c) { if (DEMO) return loadCart(); cart = c; renderCart(); })
      .catch(function (e) { toast(esc((e && e.description) || T.error)); });
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('#cartBtn') && openCart()) e.preventDefault();
    });
    var x = $('#closeCart'); if (x) x.onclick = closeCart;
    var s = $('#scrim'); if (s) s.onclick = closeCart;
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
    var body = $('#cartBody');
    if (body) body.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line]'); if (b) change(b.getAttribute('data-line'), Number(b.getAttribute('data-q')));
    });
    // Voorbeeldsokken
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-demo-add]'); if (!b || !DEMO) return;
      e.preventDefault(); addDemo(b.getAttribute('data-demo-add'), 1);
    });
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('form[data-demo-form]'); if (!f) return;
      e.preventDefault();
      if (DEMO) addDemo(f.getAttribute('data-h'), Number((f.querySelector('[name="quantity"]') || {}).value) || 1, true);
    });
    // Snel toevoegen vanaf productkaarten
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-add]'); if (!b) return;
      e.preventDefault(); b.disabled = true;
      add(b.getAttribute('data-add'), 1, b.getAttribute('data-name')).then(function () { b.disabled = false; });
    });
    // Productformulieren
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('form[data-product-form]'); if (!f || !window.fetch) return;
      e.preventDefault();
      var id = f.querySelector('[name="id"]').value, q = Number((f.querySelector('[name="quantity"]') || {}).value) || 1;
      var sb = f.querySelector('[type="submit"]'); if (sb) sb.disabled = true;
      add(id, q, '', true).then(function () { if (sb) sb.disabled = false; });
    });
  }

  /* ---------- Hero met kleurkiezer ---------- */
  function initHero(root) {
    $$('.hero[data-hero]', root).forEach(function (hero) {
      if (hero._stop) hero._stop();
      var data; try { data = JSON.parse($('script[type="application/json"]', hero).textContent); } catch (e) { return; }
      var socks = data.socks || []; if (!socks.length) return;
      var auto = data.auto !== false, speed = Math.min(12, Math.max(2, Number(data.speed) || 4.5));
      var words = $$('.js-word > span', hero);
      var img = $('.js-img', hero), prog = $('.js-prog', hero);
      var i = 0, t0 = performance.now(), last = t0, visible = true, paused = false, raf;
      var set = function (n) {
        i = (n + socks.length) % socks.length; var p = socks[i];
        hero.style.setProperty('--theme-bg', p.bg); hero.style.setProperty('--theme-accent', p.ac);
        if (img) {
          img.classList.add('out');
          setTimeout(function () {
            img.src = p.img || ''; img.srcset = p.srcset || ''; img.alt = p.title || '';
            img.classList.toggle('is-cutout', !!p.cutout); img.classList.remove('out');
          }, 250);
        }
        var em = $('.js-emoji', hero); if (em) { em.textContent = p.emoji || ''; em.style.transform = 'rotate(' + (i % 2 ? -12 : 12) + 'deg)'; }
        var tag = $('.js-tag', hero);
        if (tag) tag.innerHTML = esc(p.title) + '<small>' + (p.tag ? esc(p.tag) + ' · ' : '') + esc(p.price) + '</small>';
        $$('.js-link', hero).forEach(function (a) { a.href = p.url; });
        words.forEach(function (w, k) { w.classList.toggle('on', k === i % words.length); });
        $$('.swatch', hero).forEach(function (s, k) { s.classList.toggle('on', k === i); s.setAttribute('aria-pressed', k === i); });
        t0 = performance.now();
      };
      var sw = $('.js-swatches', hero);
      if (sw) sw.onclick = function (e) { var b = e.target.closest('.swatch'); if (b) set(Number(b.getAttribute('data-i'))); };
      set(0);
      var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0 }) : null;
      if (io) io.observe(hero);
      var tick = function (now) {
        if (!visible || paused || document.hidden) t0 += now - last;
        last = now;
        var d = auto ? (now - t0) / (speed * 1000) : 0;
        if (prog) prog.style.transform = 'scaleX(' + Math.min(1, d).toFixed(4) + ')';
        if (d >= 1) set(i + 1);
        raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);
      hero._stop = function () { cancelAnimationFrame(raf); if (io) io.disconnect(); };
      hero._show = function (n) { paused = true; set(n); };
      hero._resume = function () { paused = false; };
    });
  }

  /* ---------- Winkelpagina: zoeken en filteren ---------- */
  function initFilters(root) {
    $$('[data-filters]', root).forEach(function (box) {
      var grid = $('[data-grid]'); if (!grid) return;
      var q = $('[data-q]', box), stock = $('[data-stock]', box), sort = $('[data-sort]', box), dsort = $('[data-demo-sort]', box);
      var count = $('[data-count]'), empty = $('[data-empty]'), hero = $('[data-shop-hero]');
      var cards = $$('.card', grid), chips = $$('[data-cat-chip]', box), cat = '';
      var draw = function () {
        var term = q ? q.value.trim().toLowerCase() : '';
        var n = 0;
        cards.forEach(function (c) {
          var ok = (!stock || !stock.checked || c.getAttribute('data-available') === 'true') &&
                   (!cat || c.getAttribute('data-cat') === cat) &&
                   (!term || (c.getAttribute('data-search') || '').indexOf(term) > -1);
          c.hidden = !ok; if (ok) n++;
        });
        if (count) count.textContent = n === 1 ? T.countOne : fmt(T.countMany, { n: n }).replace(/<[^>]+>/g, '');
        if (empty) empty.hidden = n > 0;
      };
      var setCat = function (k) {
        cat = k || '';
        var chip = chips.filter(function (c) { return c.getAttribute('data-cat-chip') === cat; })[0];
        chips.forEach(function (c) { c.classList.toggle('on', c === chip); });
        if (hero) {
          var src = cat && chip ? chip : hero;
          hero.style.setProperty('--sh-bg', src.getAttribute('data-bg') || hero.getAttribute('data-bg'));
          var t = $('[data-shop-title]', hero), l = $('[data-shop-lead]', hero), ca = $('[data-crumb-all]', hero), cc = $('[data-crumb-cat]', hero);
          if (t) t.textContent = src.getAttribute('data-title');
          if (ca) ca.innerHTML = cat ? '<a href="' + esc(location.pathname + location.search.replace(/[?&]cat=[^&]*/, '')) + '" data-cat-link>' + esc(hero.getAttribute('data-title')) + '</a>' : esc(hero.getAttribute('data-title'));
          if (cc) cc.textContent = cat ? ' / ' + chip.getAttribute('data-title') : '';
          var stack = $('[data-stack]', hero);
          if (stack) {
            var picks = (cat ? cards.filter(function (c) { return c.getAttribute('data-cat') === cat; }) : cards.filter(function (c) { return c.getAttribute('data-top') === '1'; }))
              .filter(function (c) { return c.getAttribute('data-available') === 'true'; }).slice(0, 3);
            stack.innerHTML = picks.map(function (c) {
              var m = $('.card__media', c), im = $('img', c), a = $('a', c);
              return '<a class="sk" href="' + esc(a.getAttribute('href')) + '" style="--c:' + esc(m.style.getPropertyValue('--c')) + '" tabindex="-1"><img src="' + esc(im.getAttribute('src')) + '" alt=""></a>';
            }).join('');
          }
          if (l) l.textContent = src.getAttribute('data-lead');
          var nEl = $('[data-stat-n]', hero), sEl = $('[data-stat-stock]', hero);
          var pool = cards.filter(function (c) { return !cat || c.getAttribute('data-cat') === cat; });
          if (nEl) nEl.textContent = pool.length;
          if (sEl) sEl.textContent = pool.filter(function (c) { return c.getAttribute('data-available') === 'true'; }).length;
        }
        var pack = $('[data-pack]'); if (pack) pack.hidden = cat === 'packs';
        draw();
      };
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          setCat(c.getAttribute('data-cat-chip'));
          var u = new URL(location.href); if (cat) u.searchParams.set('cat', cat); else u.searchParams.delete('cat');
          history.replaceState(null, '', u.toString()); markMenu();
        });
      });
      if (q) q.addEventListener('input', draw);
      if (stock) stock.addEventListener('change', draw);
      if (sort) sort.addEventListener('change', function () {
        var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString();
      });
      if (dsort) dsort.addEventListener('change', function () {
        var v = dsort.value, num = function (c, k) { return Number(c.getAttribute(k)) || 0; };
        var off = function (c) { var w = num(c, 'data-was'), p = num(c, 'data-price'); return w > p ? 1 - p / w : 0; };
        var list = cards.slice();
        list.sort(function (a, b) {
          if (v === 'low') return num(a, 'data-price') - num(b, 'data-price');
          if (v === 'high') return num(b, 'data-price') - num(a, 'data-price');
          if (v === 'az') return $('.card__title', a).textContent.localeCompare($('.card__title', b).textContent);
          if (v === 'deal') return off(b) - off(a);
          return num(b, 'data-top') - num(a, 'data-top');
        });
        list.sort(function (a, b) { return (a.getAttribute('data-available') === 'false') - (b.getAttribute('data-available') === 'false'); });
        list.forEach(function (c) { grid.appendChild(c); });
      });
      var reset = $('[data-reset]'); if (reset) reset.onclick = function () { if (q) q.value = ''; if (stock) stock.checked = false; setCat(''); };
      box.addEventListener('click', function () {});
      document.addEventListener('click', function (e) { var l = e.target.closest('[data-cat-link]'); if (l) { e.preventDefault(); setCat(''); history.replaceState(null, '', l.getAttribute('href')); markMenu(); } });
      if (dsort) dsort.dispatchEvent(new Event('change'));
      var start = new URLSearchParams(location.search).get('cat');
      if (chips.length && start) setCat(start); else if (q && q.value) draw();
    });
  }

  /* ---------- Voorbeeldsok: aantal ---------- */
  function initDemoForm(root) {
    $$('form[data-demo-form]', root).forEach(function (f) {
      var qty = $('[name="quantity"]', f), btn = $('[data-add-btn]', f); if (!qty || !btn) return;
      var price = Number(f.getAttribute('data-price')) || 0, label = btn.getAttribute('data-label');
      var upd = function () { var q = Math.max(1, Number(qty.value) || 1); qty.value = q; btn.innerHTML = esc(label) + ' · ' + money(price * q); };
      $$('[data-qty]', f).forEach(function (b) { b.onclick = function () { qty.value = Math.max(1, (Number(qty.value) || 1) + Number(b.getAttribute('data-qty'))); upd(); }; });
      qty.addEventListener('change', upd);
    });
  }

  /* ---------- Productpagina ---------- */
  function initProduct(root) {
    $$('[data-pdp]', root).forEach(function (pdp) {
      var form = $('form[data-product-form]', pdp); if (!form) return;
      var qty = $('[name="quantity"]', form), idInput = $('[name="id"]', form), addBtn = $('[data-add-btn]', form);
      var variants = []; try { variants = JSON.parse($('script[data-variants]', pdp).textContent); } catch (e) {}
      var current = variants.find ? variants.find(function (v) { return String(v.id) === idInput.value; }) : null;
      var label = addBtn ? addBtn.getAttribute('data-label') : '';
      var upd = function () {
        var q = Math.max(1, Number(qty.value) || 1); qty.value = q;
        if (!addBtn || !current) return;
        addBtn.disabled = !current.available;
        addBtn.innerHTML = current.available ? esc(label) + ' · ' + money(current.price * q) : esc(addBtn.getAttribute('data-out'));
      };
      $$('[data-qty]', form).forEach(function (b) {
        b.onclick = function () { qty.value = Math.max(1, (Number(qty.value) || 1) + Number(b.getAttribute('data-qty'))); upd(); };
      });
      qty.addEventListener('change', upd);
      var sel = $('[data-variant-select]', pdp);
      if (sel) sel.addEventListener('change', function () {
        current = variants.filter(function (v) { return String(v.id) === sel.value; })[0];
        if (!current) return;
        idInput.value = current.id;
        var pr = $('[data-price]', pdp);
        if (pr) pr.innerHTML = '<div class="price">' + (current.compare_at_price > current.price ? '<s>' + money(current.compare_at_price) + '</s>' : '') + '<span class="now">' + money(current.price) + '</span></div>';
        if (current.featured_image) {
          var im = $('.js-main-img', pdp);
          if (im) { im.src = current.featured_image.src; im.removeAttribute('srcset'); }
        }
        var u = new URL(location.href); u.searchParams.set('variant', current.id); history.replaceState(null, '', u.toString());
        upd();
      });
      $$('[data-thumb]', pdp).forEach(function (t) {
        t.onclick = function () {
          var im = $('.js-main-img', pdp); if (!im) return;
          im.src = t.getAttribute('data-thumb'); im.removeAttribute('srcset');
          $$('[data-thumb]', pdp).forEach(function (x) { x.classList.toggle('on', x === t); });
        };
      });
      upd();
    });
  }

  /* Voorbeeldmodus: links naar winkel/pagina's die nog niet bestaan omzetten naar de voorbeeldpagina's */
  function demoLinks(root) {
    if (!DEMO) return;
    var sr = (routes.search || '/search') + '?q=';
    $$('a[href]', root).forEach(function (a) {
      var h = a.getAttribute('href') || '', m;
      if (/^https?:/i.test(h) && h.indexOf(location.origin) !== 0) return;
      var path = h.replace(location.origin, '').replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, '');
      if ((m = path.match(/^\/collections(?:\/[^?#]*)?(?:\?(.*))?$/))) a.setAttribute('href', sr + 'pagina-shop' + (m[1] ? '&' + m[1] : ''));
      else if (/^\/pages\/(faq|veelgestelde)/i.test(path)) a.setAttribute('href', sr + 'pagina-faq');
      else if (/^\/pages\/over/i.test(path)) a.setAttribute('href', sr + 'pagina-over');
      else if (/^\/pages\/contact/i.test(path)) a.setAttribute('href', sr + 'pagina-contact');
      else if ((m = path.match(/^\/products\/([^?#/]+)/)) && DEMO.items[m[1]]) a.setAttribute('href', sr + 'sok-' + m[1] + '&type=product');
    });
  }
  function markMenu() {
    var cur = new URLSearchParams(location.search);
    $$('#menu a').forEach(function (a) {
      var u = new URL(a.getAttribute('href'), location.href);
      var on = u.pathname === location.pathname && (u.searchParams.get('q') || '') === (cur.get('q') || '') && (u.searchParams.get('cat') || '') === (cur.get('cat') || '');
      if (on) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
    });
  }
  function initQuiz(root) {
    $$('[data-quiz]', root).forEach(function (box) {
      if (box._quiz) return; box._quiz = 1;
      var data; try { data = JSON.parse(box.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
      (data.questions || []).forEach(function (q) {
        (q.options || []).forEach(function (o) {
          var s = o.sock; if (!s) return;
          if (s.demo && DEMO) {
            if (DEMO.items[s.demo] && !DEMO.items[s.demo].out) s.add = function () { addDemo(s.demo, 1, true); };
          } else if (s.variant) s.add = function () { add(s.variant, 1, s.t, true); };
        });
      });
      sksQuiz(box, data, esc);
    });
  }
  function initDuo(root) {
    $$('[data-duo]', root).forEach(function (box) {
      if (box._duo) return; box._duo = 1;
      var data; try { data = JSON.parse(box.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
      sksDuo(box, data, esc, money, function (a, b) {
        if (DEMO && a.demo) {
          [a, b].forEach(function (s) { var l = dcart.filter(function (x) { return x.h === s.demo; })[0]; if (l) l.q += 1; else dcart.push({ h: s.demo, q: 1 }); });
          saveDemo(); loadCart(); bump(); openCart(); return;
        }
        if (!a.variant || !b.variant || busy) return;
        busy = true;
        var items = a.variant === b.variant ? [{ id: a.variant, quantity: 2 }] : [{ id: a.variant, quantity: 1 }, { id: b.variant, quantity: 1 }];
        api(url('cartAdd', '/cart/add'), { items: items })
          .then(function () { return loadCart(); })
          .then(function () { bump(); openCart(); })
          .catch(function (e) { toast(esc((e && (e.description || e.message)) || T.error)); })
          .then(function () { busy = false; });
      });
    });
  }
  function initLine(root) {
    $$('[data-waslijn]', root).forEach(function (box) {
      if (box._wl) return; box._wl = 1;
      var data; try { data = JSON.parse(box.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
      sksLine(box, data, esc);
    });
  }
  function init(root) { demoLinks(root); initHero(root); initFilters(root); initProduct(root); initDemoForm(root); initQuiz(root); initDuo(root); initLine(root); markMenu(); }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader(); initCart(); init(document);
    if (window.fetch) loadCart().catch(function () {});
  });

  /* ---------- Shopify-editor ---------- */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); if (e.target.querySelector('#siteHeader')) initHeader(); });
  document.addEventListener('shopify:section:unload', function (e) { $$('.hero[data-hero]', e.target).forEach(function (h) { if (h._stop) h._stop(); }); });
  document.addEventListener('shopify:block:select', function (e) {
    var hero = e.target.closest('.hero[data-hero]');
    if (hero && hero._show) hero._show(Number(e.target.getAttribute('data-i')) || 0);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var hero = e.target.closest('.hero[data-hero]'); if (hero && hero._resume) hero._resume();
  });

  window.SKS_cart = { open: openCart, close: closeCart, add: add, reload: loadCart };
})();
